import { render, staticRenderFns } from "./openindicator.vue?vue&type=template&id=08735b8b&"
import script from "./openindicator.vue?vue&type=script&lang=js&"
export * from "./openindicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08735b8b')) {
      api.createRecord('08735b8b', component.options)
    } else {
      api.reload('08735b8b', component.options)
    }
    module.hot.accept("./openindicator.vue?vue&type=template&id=08735b8b&", function () {
      api.rerender('08735b8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/select/openindicator.vue"
export default component.exports